import { ReactNode, useId } from 'react'

interface ComponentsProps {
  element: ReactNode
  name: string
}

interface Props {
  components?: ComponentsProps[]
  currentChildIndex: number
  setCurrentChildIndex: (index: number) => void
  onClick?: (props: { name: string; index: number }) => void
}

const SliderHeader = ({
  components = [],
  currentChildIndex,
  setCurrentChildIndex,
  onClick,
}: Props) => {
  const key = useId()
  const sliderClasses = [
    'w-full',
    'transition-all',
    'duration-500',
    'h-[36px]',
    'flex-center',
    'cursor-pointer',
    'box-border',
  ]
  return (
    <div className='border-s border-gray bg-light-gray rounded-md overflow-hidden flex-center gap-0 mb-lg small-normal'>
      {components.map(({ name }, index) => (
        <div
          className={`${sliderClasses.join(' ')} ${
            currentChildIndex === index
              ? 'bg-black text-white'
              : 'bg-light-gray text-dark-gray hover:bg-gray hover:text-black'
          }`}
          onClick={() => {
            setCurrentChildIndex(index)
            !!onClick && onClick({ name, index })
          }}
          key={key + index}
        >
          {name}
        </div>
      ))}
    </div>
  )
}

export default SliderHeader
